import React from "react";
import './languageSwitcher.css';
import { useTranslation } from "react-i18next";
import i18n, { t } from 'i18next';

export default function LanguageSwitcher() {

    const currentLanguageCode =  'ua';
    const { t } = useTranslation();
    
    const changeLanguage = (language) => {
        i18n.changeLanguage(language);
        console.log(currentLanguageCode)
        currentLanguageCode = language;
        this.forceUpdate();
    };


    return(
        <div className="languageSwitcher">
            <button className={t("header.languageSwitcher-ua")} onClick={() => changeLanguage("ua")}>UA</button>
            <button className={t("header.languageSwitcher-ru")} onClick={() => changeLanguage("ru")}>RU</button>
        </div>
    )
}